// extracted by mini-css-extract-plugin
module.exports = {"dimmer":"PopupSmall_dimmer__1f9ru","popup":"PopupSmall_popup__2MHJB","popupContainer":"PopupSmall_popupContainer__1nK9u","popupClose":"PopupSmall_popupClose__3ctn9"};